import { apiRequest } from ".";

export const getConnectedPlatformsApi = ({
  linkTokenEndpoint,
  linkHeaders,
  page = 1,
  limit = 100,
}: {
  linkTokenEndpoint: string;
  linkHeaders: Record<string, unknown>;
  page?: number;
  limit?: number;
}) => {
  const url = linkTokenEndpoint + `?page=${page}&limit=${limit}`;

  return apiRequest({
    method: "POST",
    url: url,
    headers: linkHeaders,
    payload: {},
    withCredentials: linkHeaders?.["X-Pica-Use-Headers"] === "true"
  });
};

// Wrapper function for the pagination utility
export const getConnectedPlatformsPaginated = (
  linkTokenEndpoint: string,
  linkHeaders: Record<string, unknown>
) => {
  return (page: number, limit: number) => 
    getConnectedPlatformsApi({ linkTokenEndpoint, linkHeaders, page, limit });
};
